import React from 'react';
import PropTypes from 'prop-types';

import Label from 'Components/forms/label/Label';
import Button from 'Components/Button/Button';
import InformationBubble from 'Components/information-bubble/InformationBubble';

const TextField = ({ error, fieldErrorClass, fieldClass, htmlFor, labelClass, labelContent, children, helperText, isRequired, width, display, hideLabel, removeFilterAction, showDynamicFilter, updatedId, callingComponent, filterErrorMsg, reportName, isAllMerchantSelected, allMerchantSelectedMsg, acqCode, showTooltip, tooltipDescription }) => {
  const langCode = JSON.parse(sessionStorage.getItem('state')).auth.user.languageAbbr;
  return (
    <div className="field-group-vertical">
       {reportName === "MRE" && isAllMerchantSelected && <span style={{ "color": "rgba(15, 125, 196, 1)", fontFamily: 'Roboto', fontStyle: "normal", fontWeight: 400, fontSize: "10px",marginTop: "-15px" }}>{allMerchantSelectedMsg}</span>}
      <div className={error ? fieldErrorClass : fieldClass} style={{ width, display }}>
        {!hideLabel && (
          <Label
            labelClass={labelClass}
            htmlFor={htmlFor}
            helperText={helperText}
            callingComponent={callingComponent}
          >
            <span>{labelContent}</span>
            {isRequired && <span style={{"color": "#f4364c"}} className="field__required">*</span>}
            {showTooltip && 
              <InformationBubble
                id={htmlFor}
                info
                position="top"
                tooltipContent={tooltipDescription}
              />
            }
            {reportName === 'MRE' && filterErrorMsg && 
              <span style={
                { "color": "red", 
                  fontFamily: 'Roboto', 
                  fontStyle: "normal", 
                  fontWeight: 400, 
                  fontSize: "11px", 
                  marginLeft: "8px",
                  whiteSpace : langCode == "FC" || acqCode == "HPY" ? "normal" : "nowrap" 
                }}>
                {filterErrorMsg}
              </span>
            }
            {showDynamicFilter && (
              <Button
                action={() => removeFilterAction(updatedId)}
                extraClass="clear-filters"
                category="link-inline"
                id={`_btn_clear`}
                style={{height:'20px'}}
              >
                &nbsp;&nbsp;<u>remove</u>
              </Button>
            )}
          </Label>

        )}
        {children}
      </div>
    </div>
  );
};

TextField.propTypes = {
  htmlFor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  fieldClass: PropTypes.string,
  fieldErrorClass: PropTypes.string,
  labelClass: PropTypes.string,
  labelContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  children: PropTypes.any,
  error: PropTypes.string,
  helperText: PropTypes.string,
  hideLabel: PropTypes.bool,
  removeFilterAction: PropTypes.func,
  showDynamicFilter: PropTypes.bool,
  updatedId: PropTypes.string,
  acqCode: PropTypes.string,
};

TextField.defaultProps = {
  fieldClass: 'field',
  labelClass: 'field-label',
  fieldErrorClass: 'field field-danger',
  error: '',
  helperText: '',
  hideLabel: false,
  removeFilterAction: () => { },
  showDynamicFilter: false,
  updatedId: '',
  acqCode: '',
  labelContent: ''
};

export default TextField;
